<template>
  <div class="banner_head">
    <!-- ---------- -->

    <div class="banner_warp" :style="styleHeight">
      <img class="banner_warp_img" :src="bannerImg"/>
      <div class="banner_warp_text" :style="textStyle">
        <h1 :style="bannerTitleStyle" class="banner_warp_text_h1">{{ bannerH }}</h1>
        <p :style="textContentStyle">
          <span v-html="bannerP"></span>
<!--          {{ bannerP }}-->
        </p>
      </div>
    </div>

    <!-- --------- -->
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {};
  },
  props: ["bannerH", "bannerP", "bannerImg", "styleHeight", "textStyle","textContentStyle","bannerTitleStyle"],
};
</script>
<style scoped lang="scss">
.banner_warp {
  position: relative;
  width: 100vw;
  //: 1300px;
  height: 23rem;
  //margin-top: 1rem;

  .banner_warp_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 1150px) {
    .banner_warp_text {
      width: 100% !important;
      height: 100% !important;
      //background-color: rgba(255, 255, 255, .5) !important;
    }
  }

  .banner_warp_text {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 50%;
    height: 75%;
    margin: 0 auto;
    margin-bottom: 30rem;
    padding-bottom: 2rem;
    background-color: #ffffff;
    border-radius: 0 0 15rem 0;

    &::-webkit-scrollbar {
      display: none;
    }

    h1 {
      text-align: left;
      padding-top: 3rem;
      padding-left: 5rem;
      font-size: 52px;
      font-family: SourceHanSansCN;
      font-weight: 500;
      color: $shanMai_blue;
      line-height: 1;

      @media screen and (min-width: 500px) and (max-width: 2100px){
        font-size: 2rem !important;
      }

      @media screen and (max-width: 500px){
        font-size: 2rem !important;
      }
    }

    p {
      margin-top: 2rem;
      text-align: left;
      padding-left: 5rem;
      padding-right: 10rem;
      padding-bottom: 10rem;
      font-size: 1.2rem;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #333;
      line-height: 1.7;
      overflow: hidden;
      text-indent: 3rem;

      @media screen and (max-width: 1240px) {
        font-size: 1.1rem !important;
        width: 115%;
      }

      @media screen and (max-width: 550px) {
        font-size: 1rem !important;
        width: 100%;
        padding-left: 1rem;
        padding-right: 1rem;
      }

      @media screen and (max-width: 500px) {
        font-size: .9rem !important;
        width: 100%;
        padding-left: 0.6rem;
        padding-right: 0.6rem;
        line-height: 1.4;
      }
    }
  }
}


</style>
